import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.renderClearButton()
  }

  change(event) {
    this.dispatchChange(event.target.matches("[data-people-filter-search]") ? "search" : "planning")
  }

  clear() {
    const searchInput = this.element.querySelector("[data-people-filter-search]")
    if (searchInput) searchInput.value = ""
    this.element.querySelectorAll("[data-people-filter-option], [data-people-filter-effect-option]").forEach((option) => {
      option.checked = false
    })

    this.dispatchChange("all")
  }

  dispatchChange(kind) {
    this.renderClearButton()
    this.dispatch("change", {detail: {...this.currentState(), kind}})
  }

  currentState() {
    const planningFilters = {}

    this.element.querySelectorAll("[data-people-filter-option]:checked").forEach((option) => {
      const categoryId = option.dataset.peopleFilterCategoryId
      const value = option.value
      if (!categoryId || !value) return

      planningFilters[categoryId] ||= []
      planningFilters[categoryId].push(value)
    })

    const planningEffects = Array.from(
      this.element.querySelectorAll("[data-people-filter-effect-option]:checked"),
      (option) => option.value
    )

    return {
      search: this.element.querySelector("[data-people-filter-search]")?.value || "",
      planningFilters,
      planningEffects,
    }
  }

  renderClearButton() {
    const clearButton = this.element.querySelector("[data-people-filter-clear]")
    if (!clearButton) return

    const state = this.currentState()
    clearButton.disabled = !state.search.trim() &&
      Object.keys(state.planningFilters).length === 0 &&
      state.planningEffects.length === 0
  }
}
